import './styles/default.css';

import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';

ReactDOM.render(<Root />, document.getElementById('root'));
document.body.classList.remove('loading');



// WEBPACK FOOTER //
// ./src/index.js